import React from 'react';

/* External */
import { useSelector } from 'react-redux';

/* Material UI */
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

function ButtonWithLoader(props) {
  const {
    loading,
    buttonId,
    onClick,
    disabled,
    autoFocus,
    fullWidth,
    className,
    size,
    color,
    variant,
    startIcon,
    children,
  } = props;

  const globalLoading = useSelector((state) => state['app'].loaders[buttonId]);

  const localOnClick = (event) => {
    if (!(disabled && (loading || globalLoading))) onClick(event);
  };

  return (
    <Button
      color={color || 'primary'}
      onClick={localOnClick}
      variant={variant || 'contained'}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={15} /> : startIcon}
      autoFocus={autoFocus}
      fullWidth={fullWidth}
      className={className}
      size={size}>
      {children}
    </Button>
  );
}

export default ButtonWithLoader;
